import {Routes, Route} from "react-router-dom";
import React from "react";
import Budget from "./component/Budget/budget";
import NewMinistry from "./component/AboutUs/NewMinistry";
import UpdatedHome from "./component/updatedHome/UpdatedHome";
import Law from "./component/Law/Law";
import ComingSoon from "./component/ComingSoon";
import FindOrganization from "./component/FindOrganization";
console.log('window.location', window.location);
export default class RounterUrl extends React.Component {
  render() {
    return (
      <Routes>
        <Route path="/home" element={<UpdatedHome />} />
        {/*<Route path="/" element={<ComingSoon/>}/>*/}
          <Route path="/" element={<FindOrganization/>}/>
        <Route path="/decision" element={<Law />} />
        <Route path="/aboutUs" element={<NewMinistry />} />
        <Route path="/budget" element={<Budget />} />
      </Routes>
    );
  }
}
